/**
 * Placeholder tokens in URL templates that get replaced with actual values
 */
export const LINK_TEMPLATE_TOKENS = {
  FILE_ID: '{{fileId}}',
  FORMAT: '{{format}}',
  MEDIA_ID: '{{mediaId}}',
  PLAYER_ID: '{{playerId}}',
} as const;

/**
 * Query key factory for link-related queries
 */
export const LINK_QUERY_KEYS = {
  all: ['link'] as const,
  sharedConfig: (cId: number) => [...LINK_QUERY_KEYS.all, 'sharedConfig', cId] as const,
} as const;
